const email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/

const passNumber = /[0-9]/
const passMinus = /[a-z]/
const passMayus = /[A-Z]/
const passSpecial = /[!@#$%^&*()+\-_]/


export {
  email,
  passNumber,
  passMinus,
  passMayus,
  passSpecial,
}
